import React, {createContext, useCallback, useContext, useMemo, useReducer} from 'react';
import {actions, initialState} from './actions';
import {reducer} from './EQHToast.reducer';

const EQHToastContext = createContext();

const EQHToastProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const setNotification = useCallback(async (title, message) => {
    dispatch({type: actions.SET_NOTIFICATION, payload: {title, message}})
  }, []);

  const removeNotification = useCallback(async () => {
    dispatch({type: actions.SET_NOTIFICATION, payload: {}})
  }, []);

  const value = useMemo(() => ({
    notification: state.notification,
    setNotification,
    removeNotification,
  }), [removeNotification, setNotification, state.notification]);

  return (
    <EQHToastContext.Provider value={value}>
      {children}
    </EQHToastContext.Provider>
  )
};
const useEQHToastContext = () => useContext(EQHToastContext);

export {
  EQHToastProvider,
  useEQHToastContext,
}
